/**
 * redirect-popup.js
 * v1.1.0
 *
 * Couche 1 : intercepte les clics sur les liens internes correspondant
 *            aux URLs sources (plugin Redirection)
 * Couche 2 : détecte le paramètre ?rp=1 injecté par PHP lors d'une
 *            arrivée directe sur une URL source, et ouvre la popup
 *
 * Dépend de RedirectConfig (wp_localize_script) :
 *   RedirectConfig.entries        → [{source, label, destination}]
 *   RedirectConfig.siteUrl        → URL de base du site
 *   RedirectConfig.defaultMessage → message de fallback
 */

(function () {
  'use strict';

  // ── Attend que le DOM soit prêt ──────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof RedirectConfig === 'undefined') return;
    handleInteraction();

    // ── COUCHE 2 : arrivée directe sur une URL source ──────────────────────
    // PHP a rechargé la même page avec ?rp=1&destination=https://...
    const params = new URLSearchParams(window.location.search);
    if (params.get('rp') === '1') {
      const destination = decodeURIComponent(params.get('destination') || '');
      if (!destination) {
        history.replaceState({}, document.title, window.location.pathname);
        return;
      }
      if (destination) {
        // Cherche un label dans les entrées ACF si disponible
        const currentPath = window.location.pathname.replace(/\/?$/, '/').toLowerCase();
        const entry = RedirectConfig.entries.find(function (e) {
          return e.source.replace(/\/?$/, '/').toLowerCase() === currentPath;
        });

        openModal(destination, {
          destination: destination,
          label: (entry && entry.label) ? entry.label : '',
        });

        // Nettoie l'URL dans la barre d'adresse sans recharger la page
        history.replaceState({}, document.title, window.location.pathname);
        return;
      }
    }

    // ── COUCHE 1 : interception des clics sur les liens internes ───────────
    if (RedirectConfig.entries.length) {
      bindLinks();
    }
  });


  // ── Normalise une URL en chemin relatif lowercase ────────────────────────
  function normalizePath(href) {
    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      return url.pathname.replace(/\/?$/, '/').toLowerCase();
    } catch (e) {
      return null;
    }
  }


  // ── Cherche une entrée correspondant à un lien ───────────────────────────
  // Deux stratégies :
  //   1. Lien interne → compare le chemin relatif à entry.source (plugin Redirection)
  //   2. Lien externe → compare l'URL complète à entry.source OU entry.destination (ACF)
  function findEntry(href) {
    const hrefNorm = href.replace(/\/?$/, '/').toLowerCase();

    return RedirectConfig.entries.find(function (entry) {
      const sourceNorm = entry.source.replace(/\/?$/, '/').toLowerCase();
      const destNorm   = (entry.destination || '').replace(/\/?$/, '/').toLowerCase();

      // Correspond à la source interne (chemin relatif)
      const path = normalizePath(href);
      if (path && sourceNorm === path) return true;

      // Correspond à une URL externe saisie dans ACF (source ou destination)
      if (hrefNorm === sourceNorm) return true;

      return false;
    }) || null;
  }


  // ── Parcourt tous les liens de la page ───────────────────────────────────
  function bindLinks() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      if (link.hostname === window.location.hostname) return;
      const entry = findEntry(link.href);
      if (!entry) return;

      link.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(link.href, entry);
      });
    });
  }


  // ── Ouvre la popup ───────────────────────────────────────────────────────
  function openModal(originalHref, entry) {
    const TOTAL = 5000;
    const STEP  = 1000; // Change chaque seconde
    let elapsed = 0;
    let stopped = false;
    let timer   = null;

    const modal = document.getElementById('rp-modal');
    const dest  = entry.destination || originalHref;
    const domain = getDomain(dest);
    
    const bar    = document.getElementById('rp-countdown-bar');
    const cdLine = document.getElementById('rp-countdown-text');
    const domainSpan = document.getElementById('rp-domain');
    const logoAftral = document.querySelector('#rp-logo-aftral');
    const logoInstitut = document.querySelector('#rp-logo-institut');
    const rpLogosSection = document.querySelector('#rp-logos');

    if (domain === 'aftral.com' || domain === 'aftral-rec-abskill.as2.io') {
      rpLogosSection.style.display = 'flex';
      logoInstitut.style.display = 'none';
      logoAftral.style.display = 'block';
    } 
    if (domain === 'institut.abskill.com' || domain ==='institut.aftral-rec-abskill.as2.io') {
      rpLogosSection.style.display = 'flex';
      logoAftral.style.display = 'none';
      logoInstitut.style.display = 'block';
    }
    
    if (domain !== 'aftral.com' && domain !== 'institut.abskill.com' && domain !== 'aftral-rec-abskill.as2.io' && domain !== 'institut.aftral-rec-abskill.as2.io') {
      rpLogosSection.style.display = 'none';
    }

    // Affiche le domaine dans le message
    domainSpan.textContent = domain ? domain : '';

    bar.style.width      = '0%'; // Commence à 0%
    bar.style.background = '#008bd2'; // Barre de progression en bleu foncé
    // Le fond reste bleu clair grâce au CSS (.rp-countdown-track)

    // ── Réécrit le innerHTML en premier, puis récupère les éléments ──────────
    // (évite le null sur seconds.textContent lors des réouvertures)
    cdLine.innerHTML = 'Redirection automatique dans <strong id="rp-countdown-seconds">5</strong>s — <a id="rp-countdown-cancel" style="color:#008bd2;cursor:pointer;text-decoration:underline">annuler</a>';

    const seconds    = document.getElementById('rp-countdown-seconds');
    const cancelLink = document.getElementById('rp-countdown-cancel');

    function doCancel() {
      stopped = true;
      clearTimeout(timer);
      bar.style.width      = '0%';
      bar.style.background = '#ccc';
      cdLine.innerHTML     = '<span>Redirection annulée — vous restez sur cette page.</span>';
    }

    cancelLink.onclick = function () {
      doCancel();
      closeModal();
    };

    function tick() {
      if (stopped) return;
      elapsed += STEP;
      
      // Avancement par paliers : 0% → 20% → 40% → 60% → 80% → 100%
      const progress = (elapsed / TOTAL) * 100;
      bar.style.width = Math.min(100, progress) + '%';
      
      // Utilise seconds directement (déjà récupéré après innerHTML, toujours valide)
      seconds.textContent = Math.ceil((TOTAL - elapsed) / 1000);
      if (elapsed >= TOTAL) {
        stopped = true;
        cdLine.innerHTML = '<span>Redirection en cours…</span>';
        bar.style.width  = '100%'; // Barre complètement remplie
        setTimeout(function () {
          window.location.href = dest;
        }, 800);
        return;
      }
      timer = setTimeout(tick, STEP);
    }

    // ── Bouton confirmer ────────────────────
    const confirmBtn = document.getElementById('rp-confirm');
    const newConfirm = confirmBtn.cloneNode(true);
    confirmBtn.parentNode.replaceChild(newConfirm, confirmBtn);
    newConfirm.addEventListener('click', function () {
      stopped = true;
      clearTimeout(timer);
      window.location.href = dest;
    });

    // ── Bouton annuler — stoppe le timer ET ferme la modale ──────────────────
    document.getElementById('rp-cancel').onclick = function () {
      doCancel();
      closeModal();
    };

    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('rp-modal-open');
    document.getElementById('rp-cancel').focus();

    setTimeout(tick, STEP);
  }


  // ── Ferme la popup ───────────────────────────────────────────────────────
  function closeModal() {
    const modal = document.getElementById('rp-modal');
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('rp-modal-open');
  }


  // ── Gère l'intéraction entre l'utilisateur et la modale ──────────────────
  function handleInteraction() {
    // Bouton fermer (croix)
    document.getElementById('rp-close').addEventListener('click', closeModal);

    // NB : rp-cancel n'est PAS bindé ici — son onclick est réassigné
    // à chaque openModal() pour y inclure doCancel() + closeModal()

    // Clic sur l'overlay (fond sombre)
    document.getElementById('rp-modal').addEventListener('click', function (e) {
      if (e.target === this) closeModal();
    });

    // Touche Échap
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  // Source - https://stackoverflow.com/a/30877431
// Posted by adelindev, modified by community. See post 'Timeline' for change history
// Retrieved 2026-04-13, License - CC BY-SA 3.0

function getDomain(url) {
    try {
    const urlObj = new URL(url.startsWith('http') ? url : 'https://' + url);
    let hostname = urlObj.hostname;
    
    // Enlever "www." s'il est présent au début
    if (hostname.startsWith('www.')) {
      hostname = hostname.substring(4); // Enlève les 4 premiers caractères "www."
    }
    
    return hostname;
  } catch (e) {
    return null;
  }
}

})();